import OrderRequest from './OrderRequest'

export default {
	name: 'OrderRequestApp',
	components: {
		OrderRequest
	},
	mounted: function () {
		// DOM を描画した直後に呼ばれる
		[].forEach.call(this.$el.querySelectorAll('.js-loading'), (el) => {
			el.parentNode.removeChild(el)
		})
	},
	methods: {
		setDate (date) {
			// <order-request ref="app" ... />
			this.$refs.app.setDate(date)
		}
	}
}
